export const passValidation = (context) => {
    return context.currentResult;
};
export const failValidation = (errorMessage, context) => {
    return {
        valid: false,
        errorMessages: [
            `${context.path}: ${errorMessage}`,
            ...(context.currentResult.valid
                ? []
                : context.currentResult.errorMessages),
        ],
    };
};
const initialContext = {
    path: "root",
    currentResult: { valid: true },
};
export const assert = (typePredicate) => (candidate) => {
    const validationResult = typePredicate.validate(candidate, initialContext);
    if (!validationResult.valid) {
        throw new TypeError(`Expected ${typePredicate.typeDescription} but received ${typeof candidate}.\n${validationResult.errorMessages.join("\n")}`);
    }
};
export const isType = (validate, typeDescription) => {
    const predicate = Object.assign((candidate) => {
        return validate(candidate, initialContext).valid;
    }, {
        typeDescription,
        validate: (candidate, context = initialContext) => validate(candidate, context),
    });
    const doAssert = assert(predicate);
    return Object.assign(predicate, {
        assert: doAssert,
        check: (candidate) => {
            doAssert(candidate);
            return candidate;
        },
        optional: () => {
            return isType((candidate, context) => {
                if (candidate === undefined) {
                    return passValidation(context);
                }
                return predicate.validate(candidate, context);
            }, `${typeDescription} | undefined`);
        },
    });
};
//# sourceMappingURL=core.js.map